import ArticleWithBackgroundEffect from "./ArticleWithBackgroundEffect";

export default ArticleWithBackgroundEffect;
